import * as React from "react";
import { CGI_GRADIENT_A_45DEG } from "../helpers/enums";
import { Box, Typography } from "@mui/material";

export default function FeatureBlock({ heading, text, second = false }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: { xs: 1, md: 1 / 2 },
        pb: 4,
        pl: second ? 2 : 0,
        pr: second ? 0 : 2,
      }}
    >
      <Typography
        sx={{
          background: CGI_GRADIENT_A_45DEG,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          mb: 1,
          fontSize: { xs: 17, md: 20 },
          fontWeight: 500,
        }}
      >
        {heading}
      </Typography>
      <Typography sx={{ fontSize: { xs: 12, md: 13 }, fontFamily: "Inter" }}>
        {text}
      </Typography>
    </Box>
  );
}
